// extracted by mini-css-extract-plugin
export default {"page":"money_page__oItIQ","container":"money_container__kuTCd"};